
import { types, actions } from './requests'
export const CREATECOLLECTION_TYPES = {
    ...types('CREATECOLLECTION'),
}
export const CREATECOLLECTION_ACTIONS = {
    ...actions('CREATECOLLECTION'),
}